module.exports = __webpack_public_path__ + "img/icon_discuss.1ffc7bed.svg";